import { BasicEntity } from "../../core/models/basic-entity";

export class Unit extends BasicEntity {
    //public UnitGroupId?:string;

}
